import { render, staticRenderFns } from "./PayToMandatesPage.vue?vue&type=template&id=26ac1dca&"
import script from "./PayToMandatesPage.vue?vue&type=script&lang=ts&"
export * from "./PayToMandatesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports